// Sticky add-to-cart intentionally disabled for products requiring selections.
class DisabledStickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.remove();
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', DisabledStickyAddToCart);
}

document.querySelectorAll('sticky-add-to-cart').forEach((element) => element.remove());
